import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Loader } from '../../../components/Loader';
import { fetchCompanyProperty } from '../actions';
import { selectCompanyProperty } from '../selectors';
import { selectWork } from '../../Api/selectors';
import { REQUEST_COMPANY } from '../constants';

const Container = styled.div``;

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class WithCompanyPropertyComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (!this.props.company_id) return;
    if (!this.props.value) this.props.fetch();
  }

  render() {
    if (!this.props.company_id && !this.props.isPropertyValue) return null;
    if (this.props.value === undefined && this.props.work) return <Loader small />;
    return this.props.children;
  }
}

WithCompanyPropertyComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    value: selectCompanyProperty(ownProps.company_id, ownProps.property_name),
    work: selectWork(`${REQUEST_COMPANY}-${ownProps.company_id}`),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(fetchCompanyProperty(ownProps.company_id, ownProps.property_name));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WithCompanyProperty = compose(withConnect, withRouter)(WithCompanyPropertyComp);
